import { saveAs } from "file-saver";
import JSZip from "jszip";

import { RemoteFile } from "../typings";

type FetchAndZipFilesArgs = {
  fileReferences: RemoteFile[];
  zipFolderName: string;
};

export const downloadAndZipFiles = async ({
  fileReferences,
  zipFolderName,
}: FetchAndZipFilesArgs) => {
  if (!fileReferences.length) {
    return;
  }
  const zip = new JSZip();
  const folder = zip.folder(zipFolderName);
  for (const { url, name } of fileReferences) {
    const result = await fetch(url);
    if (!result.ok) {
      return;
    }
    const blob = result.blob();
    folder?.file(name, blob);
  }

  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, zipFolderName + ".zip");
};
